webpackJsonp([1],{

/***/ "/DF0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_apollo__ = __webpack_require__("3zLD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Data_Restaurants_json__ = __webpack_require__("pAMG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Data_Restaurants_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Data_Restaurants_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Data_Categories_json__ = __webpack_require__("INDk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Data_Categories_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Data_Categories_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Button_Button__ = __webpack_require__("KluA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Button_ToggleButton__ = __webpack_require__("0SSo");
var _templateObject = _taggedTemplateLiteralLoose(['\nquery {\n\tallCategorieses {\n\t\tid\n        catName\n        iconImg {\n            url\n        }\n\t}\n}\n'], ['\nquery {\n\tallCategorieses {\n\t\tid\n        catName\n        iconImg {\n            url\n        }\n\t}\n}\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var _ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'loading-container' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'loading-icon' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        null,
        'Loading position...'
    )
);

var Home = function (_Component) {
    _inherits(Home, _Component);

    function Home() {
        _classCallCheck(this, Home);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    Home.prototype.render = function render() {
        var _this2 = this;

        var _props = this.props,
            choosenCat = _props.choosenCat,
            data = _props.data;
        var getCurrentPos = this.props.getCurrentPos;
        var handlePosToggle = this.props.handlePosToggle;
        var isLoadingPos = this.props.isLoadingPos;
        var isLocationBased = this.props.isLocationBased;
        var disabled = this.props.disabled;

        var allCategorieses = data.allCategorieses;

        // console.log(this.props.isLoading);

        if (!allCategorieses) {
            return false;
        }
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'btn-container' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Button_ToggleButton__["a" /* default */], {
                onClick: handlePosToggle,
                isLocationBased: isLocationBased
            }),
            this.props.isLoading && _ref,
            allCategorieses.map(function (item, index) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Button_Button__["a" /* default */], {
                    key: index,
                    btnTxt: item.catName,
                    onClick: function onClick() {
                        return choosenCat(item.id);
                    },
                    catBtn: 'cat-btn',
                    btnIcon: item.iconImg.url,
                    disabled: _this2.props.isLoading
                });
            })
        );
    };

    return Home;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

// Query to fetch the data you want from the json file


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_apollo__["graphql"])(Object(__WEBPACK_IMPORTED_MODULE_1_react_apollo__["gql"])(_templateObject))(Home));

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("+prg");
module.exports = __webpack_require__("lVK7");


/***/ }),

/***/ "0SSo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var _ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'slider' });

var _ref2 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'h4',
    null,
    'Filter on nearby restaurants (within 500 m)'
);

var ToggleButton = function ToggleButton(props) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'toggle-container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'label',
            { className: 'switch' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                type: 'checkbox',
                onClick: function onClick(e) {
                    props.onClick(e);
                },
                defaultChecked: props.isLocationBased ? true : false

            }),
            _ref
        ),
        _ref2
    );
};

/* harmony default export */ __webpack_exports__["a"] = (ToggleButton);

/***/ }),

/***/ "1K4x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var _ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('footer', null);

var Footer = function Footer(props) {
    return _ref;
};

/* harmony default export */ __webpack_exports__["a"] = (Footer);

/***/ }),

/***/ "2Fet":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Map_Map__ = __webpack_require__("jdcc");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var _ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-map-marker', 'aria-hidden': 'true' });

var _ref2 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'section-divider' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'header-container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h3',
            null,
            'DETAILS'
        )
    )
);

var _ref3 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: 'section-divider' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'header-container' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h3',
            null,
            'LOCATION'
        )
    )
);

var Info = function (_Component) {
    _inherits(Info, _Component);

    function Info() {
        _classCallCheck(this, Info);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    Info.prototype.render = function render() {
        var _this2 = this;

        var selectedRestaurant = this.props.selectedRestaurant;
        var currentPos = this.props.currentPos;
        //TODO: depending on rating print out an icon for each star

        var rating = selectedRestaurant.rating;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'info-container' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'rest-img', src: selectedRestaurant.restImage.url }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'info' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'h1',
                    null,
                    selectedRestaurant.name
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'address-container' },
                    _ref,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'p',
                        null,
                        ' ',
                        selectedRestaurant.address
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'p',
                    null,
                    'Cuisine: ',
                    selectedRestaurant.cuisine,
                    ' '
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'p',
                    null,
                    'Price range: ',
                    selectedRestaurant.priceRange
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'p',
                    null,
                    'Rating: ',
                    selectedRestaurant.rating
                )
            ),
            _ref2,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'info' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'p',
                    { className: 'details' },
                    ' ',
                    selectedRestaurant.desc,
                    ' '
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'a',
                    { target: '_blank',
                        href: selectedRestaurant.menuLink },
                    'To the lunch menu'
                )
            ),
            _ref3,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Map_Map__["a" /* default */], {
                position: selectedRestaurant.position,
                currentPos: currentPos,
                name: selectedRestaurant.name,
                zoom: 13,
                containerElement: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: {
                        height: 300,
                        width: '100%',
                        marginTop: 20
                    } }),
                mapElement: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: 100 + '%' } })
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { href: '#', ref: 'link', onClick: function onClick() {
                        return _this2.props.backToStart();
                    } },
                'BACK TO START'
            )
        );
    };

    return Info;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Info);

/***/ }),

/***/ "INDk":
/***/ (function(module, exports) {

module.exports = [{"name":"Formal Lunch","id":"1","imgIcon":"img/icon_formal.svg"},{"name":"Work Lunch","id":"2","imgIcon":"img/icon_work.svg"}]

/***/ }),

/***/ "KluA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var Button = function Button(_ref) {
    var catBtn = _ref.catBtn,
        onClick = _ref.onClick,
        btnIcon = _ref.btnIcon,
        btnTxt = _ref.btnTxt,
        disabled = _ref.disabled;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'button',
        {
            className: catBtn,
            style: { opacity: disabled ? 0.2 : 1 },
            onClick: onClick,
            disabled: disabled },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'btn-icon', src: btnIcon }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            null,
            btnTxt
        )
    );
};

/* harmony default export */ __webpack_exports__["a"] = (Button);

/***/ }),

/***/ "LGxg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Button_Button__ = __webpack_require__("KluA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_greensock__ = __webpack_require__("+caA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_greensock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_greensock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo__ = __webpack_require__("3zLD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_apollo__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




// import CustomEase from '../../vendor/CustomEase';


var Randomizer = function (_Component) {
    _inherits(Randomizer, _Component);

    function Randomizer(props) {
        _classCallCheck(this, Randomizer);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.slotHeight = 99;

        _this.fetchLink = function () {
            _this.isSpinning = false;
            document.querySelector('.info-link').style.display = 'block';
        };

        _this.spin = _this.spin.bind(_this);
        _this.moveSpinnerOneStep = _this.moveSpinnerOneStep.bind(_this);
        _this.stopSpinner = _this.stopSpinner.bind(_this);
        _this.fetchLink = _this.fetchLink.bind(_this);
        _this.isSpinning = false;
        return _this;
    }

    /* Spin that randomizes the value and sets the variables and calls the
       moveSpinner method */


    Randomizer.prototype.spin = function spin() {
        this.isSpinning = true;
        var restList = this.props.restaurantList;
        var randomRestIndex = Math.floor(Math.random() * restList.length);
        this.selectedRestaurant = restList[randomRestIndex];
        this.moveSpinnerOneStep(1, randomRestIndex === 0 ? restList.length : randomRestIndex, 6);
        console.log('Randomizer.spin', randomRestIndex);
    };

    Randomizer.prototype.moveSpinnerOneStep = function moveSpinnerOneStep(nextStep, selectedRestaurantIndex, fullSpins) {
        var _this2 = this;

        __WEBPACK_IMPORTED_MODULE_2_greensock__["TweenMax"].killTweensOf(this.refs.slots);

        /* If next step is equal to the restaurantsLenght +1
           The spinns left decreases with one (starting from 6) */
        if (nextStep === this.props.restaurantList.length + 1) {
            nextStep = 1;
            __WEBPACK_IMPORTED_MODULE_2_greensock__["TweenMax"].set(this.refs.slots, { y: 0 });
            fullSpins--;
        }

        /* If it the spins that are left is less or equal to zero, and steps
           to go to equals the selected restaurant index the the stopSpinner
           method is called */
        if (fullSpins <= 0 && nextStep === selectedRestaurantIndex) {
            this.stopSpinner(nextStep);
        } else {
            if (this.refs.slots) {
                __WEBPACK_IMPORTED_MODULE_2_greensock__["TweenMax"].to(this.refs.slots, 0.1, {
                    y: -nextStep * this.slotHeight,
                    ease: Linear.easeNone,
                    onComplete: function onComplete() {
                        _this2.moveSpinnerOneStep(nextStep + 1, selectedRestaurantIndex, fullSpins);
                    }
                });
            }
        }
    };

    /* Method that stops the spinner and send the selected restaurant as props??
       to the onRestaurantSelected in App component */


    Randomizer.prototype.stopSpinner = function stopSpinner(nextStep) {
        var _this3 = this;

        this.props.onRestaurantSelected(this.selectedRestaurant);

        __WEBPACK_IMPORTED_MODULE_2_greensock__["TweenMax"].to(this.refs.slots, 2.5, {
            y: -nextStep * this.slotHeight,
            ease: Bounce.easeOut,
            onComplete: function onComplete() {
                _this3.fetchLink();
            }
        });
    };

    /* Function that runs after spinner animation is finnished
       TODO: Ease in on link */


    /* From start when this component is called run this lifecycle method
       set the isLocationBase in componentDidMount, instead of currPos that we 
       had before setting the new value isLocationBased */
    Randomizer.prototype.componentDidMount = function componentDidMount() {
        this.spin();
    };

    /* When ...the lifecycle method will end all animations so they do not run
       in the background */


    Randomizer.prototype.componentWillUnmount = function componentWillUnmount() {
        __WEBPACK_IMPORTED_MODULE_2_greensock__["TweenMax"].killTweensOf(this.refs.slots);
    };

    Randomizer.prototype.render = function render() {
        var _this4 = this;

        var _props = this.props,
            restaurantList = _props.restaurantList,
            data = _props.data,
            currentPos = _props.currentPos;

        console.log("restList", restaurantList);

        var restaurants = [].concat(restaurantList, [restaurantList[0]]).map(function (restaurant, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { key: index, className: 'restaurant-container' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'p',
                    { className: 'spinner-txt' },
                    restaurant.name
                )
            );
        });

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'randomizer-container' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'slot-machine' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { ref: 'slots', className: 'slot-container' },
                    restaurants
                )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { className: 'info-link', href: '#', ref: 'link', onClick: function onClick() {
                        return _this4.props.showInfo();
                    } },
                'MORE INFO'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'a',
                { href: '#', ref: 'link', onClick: function onClick() {
                        return _this4.props.backToStart();
                    } },
                'BACK TO START'
            )
        );
    };

    return Randomizer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Randomizer);

/***/ }),

/***/ "VH3W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__("CIox");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__("F8kA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Pages_Home__ = __webpack_require__("/DF0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Pages_Randomizer__ = __webpack_require__("LGxg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Pages_Info__ = __webpack_require__("2Fet");








var _ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'header',
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'logo-container' })
);

var Header = function Header(props) {
    return _ref;
};
/* harmony default export */ __webpack_exports__["a"] = (Header);

/***/ }),

/***/ "aLQP":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "MarkerIcon.756a8c50.svg";

/***/ }),

/***/ "cilB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jdcc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_google_maps__ = __webpack_require__("BL0p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Logotypes_MarkerIcon_svg__ = __webpack_require__("aLQP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Logotypes_MarkerIcon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Logotypes_MarkerIcon_svg__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




// import GoogleMapLoader from "react-google-maps-loader";

var Map = function (_Component) {
    _inherits(Map, _Component);

    function Map() {
        _classCallCheck(this, Map);

        var _this = _possibleConstructorReturn(this, _Component.call(this));

        _this.state = {
            map: null,
            markers: []
        };
        return _this;
    }

    Map.prototype.mapLoaded = function mapLoaded(map) {
        if (this.state.map != null) {
            return;
        } else {
            this.setState({
                map: map
            });
        }
    };

    // Here you render out the Map, and Marker on page


    Map.prototype.render = function render() {
        // console.log('current',this.props.currentPos );
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_1_react_google_maps__["GoogleMap"],
            {
                ref: this.mapLoaded.bind(this),
                defaultZoom: this.props.zoom,
                defaultCenter: this.props.position },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_google_maps__["Marker"], {
                name: 'you are here',
                position: this.props.currentPos
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_google_maps__["Marker"], { className: 'marker',
                name: this.props.name,
                position: this.props.position,
                icon: {
                    url: __WEBPACK_IMPORTED_MODULE_2__Logotypes_MarkerIcon_svg___default.a,
                    scaledSize: new google.maps.Size(50, 70)
                }
            })
        );
    };

    return Map;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_google_maps__["withGoogleMap"])(Map));

// TODO: Animation on marker is not working
// animation: google.maps.Animation.BOUNCE
// TODO: rendrera ut current position från Geo.js
// TODO: lägg till center på currentPos ist defaultCenter = { this.props.currentPos }
// TODO: vid utzoomning hänger inte markören med
// TODO: Lägg till info window

/***/ }),

/***/ "lVK7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__("O27J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_apollo__ = __webpack_require__("3zLD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__("pnOm");
// import './index.css'





// render(<App/>, document.querySelector('#app'))
// ReactDOM.
var client = new __WEBPACK_IMPORTED_MODULE_2_react_apollo__["ApolloClient"]({
  networkInterface: Object(__WEBPACK_IMPORTED_MODULE_2_react_apollo__["createNetworkInterface"])({
    uri: 'https://api.graphcms.com/simple/v1/lunchapp'
  })
});

Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["render"])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  __WEBPACK_IMPORTED_MODULE_2_react_apollo__["ApolloProvider"],
  { client: client },
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */], null)
), document.getElementById('app'));

/***/ }),

/***/ "pAMG":
/***/ (function(module, exports) {

module.exports = [{"restId":"1","name":"Restaurang Tranan","menu_link":"http://www.tranan.se/restaurangen/meny/","cuisine":["European","Swedish"],"price_range":"$$-$$$","rating":"****","phone":"08-52728100","address":"Karlbergsvägen 14","cat_id":"1","img_url":"img/tranan.jpg","desc":"A place to meet at, have a bite to eat and something to drink. That was how Tranan was know in 1929 by the residents of Stockholm, and that’s how it’s still known today - over 80 years later.","position":{"lat":59.343172,"lng":18.049017}},{"restId":"2","name":"Miss Clara","menu_link":"http://www.missclarahotel.com/restaurang/lunch-meny","cuisine":["International","Swedish"],"price_range":"$$$","rating":"****","phone":"08-4406710","address":"Sveavägen 48","cat_id":"1","img_url":"img/fish_miss_clara.jpg","desc":"The kitchen’s philosophy is to work in as natural way as possible. They change our meat, fish and vegetarian dishes every week.","position":{"lat":59.337522,"lng":18.062079}},{"restId":"3","name":"Raw Sushi & Grill","menu_link":"http://raw.se/lunch/","cuisine":"Japanese","price_range":"$$-$$$","rating":"***","phone":"08-309680","address":"Rörstrandsgatan 9","cat_id":"1","img_url":"img/raw.jpg","desc":"Japan meets Europe in an elegant restaurant focusing on the rawness. At Raw sushi and sashimi coexists with hot dishes from the grill, bothmeat and shellfish.","position":{"lat":59.339795,"lng":18.033839}},{"restId":"4","name":"Hamburgarstugan","menu_link":"http://www.hamburgarstugan.se/wp-content/uploads/2016/04/Meny-Original-A4.pdf","cuisine":"Fast food","price_range":"$","rating":"***","phone":"08-216217","address":"Odengatan 53","cat_id":"2","img_url":"img/hStugan2.jpg","desc":"Come to Hamburgerstugan and get your life's best burger experience. They compile every burger with love daily. You get a day-to-day high-rise burger with home-made dressings and dip sauces. Gluten free bread is available.","position":{"lat":59.343554,"lng":18.054583}},{"restId":"5","name":"Masala Masala","menu_link":"http://www.masalamasala.se/lunchmeny/","cuisine":"Indian","price_range":"$$","rating":"**","phone":"08-12147043","address":"Odengatan 60","cat_id":"2","img_url":"img/masala.jpg","desc":"Masala Masala – Genuine Indian cuisine, also inspired by its neighboring countries. Our innovative chef has specially composed a number of new vegan dishes.","position":{"lat":59.34348,"lng":18.052472}},{"restId":"6","name":"Babel Deli","menu_link":"http://babeldeli.com/wp-content/uploads/2016/02/takeawaywebb2.pdf","cuisine":"Meze","price_range":"$$","rating":"***","phone":"08-6683903","address":"Kungstensgatan 33","cat_id":"2","img_url":"img/meze.jpg","desc":"Babel is today both on Kungstensgatan at Sveavägen and on Långholmsgatan at Hornstull. Welcome to a fantastic dining experience guaranteed by Mamma Etimad!","position":{"lat":59.341657,"lng":18.059082}},{"restId":"7","name":"Arirang","menu_link":"http://arirang.se/lunch/","cuisine":"Korean","price_range":"$$","rating":"***","phone":"08-6733225","address":"Luntmakargatan 65","cat_id":"2","img_url":"img/korean.jpg","desc":"Mild or spicy. Gentle and sweet or tantalisingly hot. Anything is possible at Arirang. You can choose how to combine our dishes yourself or you can ask us for advice.","position":{"lat":59.340634,"lng":18.060196}}]

/***/ }),

/***/ "pnOm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("U7vG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_apollo__ = __webpack_require__("3zLD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_apollo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_apollo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Layout_Header__ = __webpack_require__("VH3W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Layout_Footer__ = __webpack_require__("1K4x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Pages_Home__ = __webpack_require__("/DF0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Pages_Randomizer__ = __webpack_require__("LGxg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Pages_Info__ = __webpack_require__("2Fet");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Button_Button__ = __webpack_require__("KluA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__index_css__ = __webpack_require__("cilB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__index_css__);
var _templateObject = _taggedTemplateLiteralLoose(['\nquery {\n\tallRestaurantses {\n\t\tid\n\t\tname\n\t\tcategoryId { id }\n\t\tphoneNumber\n\t\taddress\n\t\tmenuLink\n\t\tcuisine\n\t\trating\n\t\tpriceRange\n\t\trestImage { url }\n\t\tdesc\n\t\tposition\n\t}\n}\n'], ['\nquery {\n\tallRestaurantses {\n\t\tid\n\t\tname\n\t\tcategoryId { id }\n\t\tphoneNumber\n\t\taddress\n\t\tmenuLink\n\t\tcuisine\n\t\trating\n\t\tpriceRange\n\t\trestImage { url }\n\t\tdesc\n\t\tposition\n\t}\n}\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var _ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_Layout_Footer__["a" /* default */], null);

var App = function (_Component) {
	_inherits(App, _Component);

	function App(props) {
		_classCallCheck(this, App);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		_this.state = {
			step: 1,
			selectedCategory: null,
			restaurantsList: [],
			selectedRestaurant: null,
			currentPos: null,
			// timeStamp: null,
			currentPosTimeStamp: null,
			isLocationBased: false,
			isFiltering: false,
			isLoading: false,
			disabled: false

			/* To be able to re-use the methods you bind them to the component 
      SMART TIPS: MAke a init function for all bind values and yhen just 
      call the init function value */
		};_this.onRestaurantSelected = _this.onRestaurantSelected.bind(_this);
		_this.choosenCat = _this.choosenCat.bind(_this);
		_this.showInfo = _this.showInfo.bind(_this);
		_this.backToStart = _this.backToStart.bind(_this);
		_this.getCurrentPos = _this.getCurrentPos.bind(_this);
		_this.onCurrentPos = _this.onCurrentPos.bind(_this);
		_this.filterOnCat = _this.filterOnCat.bind(_this);
		_this.shouldPosBeUpdated = _this.shouldPosBeUpdated.bind(_this);
		_this.filterOnLocation = _this.filterOnLocation.bind(_this);
		_this.handlePosToggle = _this.handlePosToggle.bind(_this);

		return _this;
	}

	//Function called when user presses a category button


	App.prototype.choosenCat = function choosenCat(category) {
		var _this2 = this;

		this.setState({
			isFiltering: true
		});
		if (this.state.isLocationBased) {
			this.filterOnCat(this.props.data.allRestaurantses, category).then(function (resturants) {
				_this2.filterOnLocation(resturants).then(function (resturants) {
					_this2.setState({
						step: 2,
						selectedCategory: category,
						restaurantsList: resturants,
						isFiltering: false,
						isLoading: true
					});
					_this2.shouldPosBeUpdated();
				});
			});
		} else {
			this.filterOnCat(this.props.data.allRestaurantses, category).then(function (resturants) {
				_this2.setState({
					step: 2,
					selectedCategory: category,
					restaurantsList: resturants,
					isFiltering: false
				});
			});
		}
	};

	/* When this function is called set isLocationBased to false 
    for it to reload so click button several times */


	App.prototype.backToStart = function backToStart() {
		this.setState({ step: 1, isLoading: false });
	};

	App.prototype.showInfo = function showInfo() {
		this.setState({ step: 3 });
	};

	App.prototype.onRestaurantSelected = function onRestaurantSelected(restaurant) {
		this.setState({ selectedRestaurant: restaurant });
	};
	//IF toggle btn is checked then get current position


	App.prototype.handlePosToggle = function handlePosToggle(e) {
		this.setState({ isLocationBased: true });
		if (e.target.checked) {
			this.setState({
				isLoading: true
			});

			this.getCurrentPos();
		} else {
			this.setState({
				currentPos: null,
				isLocationBased: false
			});
		}
	};

	App.prototype.shouldPosBeUpdated = function shouldPosBeUpdated() {
		var currentTime = new Date();
		if (Math.floor((currentTime - this.state.currentPosTimeStamp) / 60000) >= 1) {
			this.getCurrentPos();
			console.log('uppdaterar');
		} else {
			console.log('behåller gamla positionen');
		}
	};

	App.prototype.getCurrentPos = function getCurrentPos() {
		this.setState({ isLocationBased: true });
		if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(this.onCurrentPos, function () {});
		} else {
			// Browser doesn't support Geolocation
			this.setState({ currentPos: null, isLocationBased: false });
		}
	};

	App.prototype.onCurrentPos = function onCurrentPos(position) {
		var timeStamp = new Date();
		this.setState({
			currentPos: {
				lat: position.coords.latitude,
				lng: position.coords.longitude
			},
			currentPosTimeStamp: timeStamp,
			isLoading: false
		});

		console.log('current time stamp' + this.state.currentPosTimeStamp);
	};

	/* Filter function that filter the choosen category */


	App.prototype.filterOnCat = function filterOnCat(restaurantList, category) {
		return new Promise(function (resolve, reject) {
			var newList = restaurantList.filter(function (restaurant) {
				return restaurant.categoryId.some(function (cat) {
					return cat.id === category;
				});
			});
			resolve(newList);
		});
	};

	App.prototype.filterOnLocation = function filterOnLocation(restaurantList) {
		var _this3 = this;

		return new Promise(function (resolve, reject) {
			var geoList = restaurantList.filter(function (restaurant) {
				var restLongLat = new google.maps.LatLng({ lat: restaurant.position.lat, lng: restaurant.position.lng });
				var myLongLat = new google.maps.LatLng({ lat: _this3.state.currentPos.lat, lng: _this3.state.currentPos.lng });

				/* computeDistanceBetween = built in function in google maps
    	that calculates the distance between two locations*/
				var distance = google.maps.geometry.spherical.computeDistanceBetween(restLongLat, myLongLat);

				/* if distance is more then 500 m return return false 
    	restaurant further away will not be added to array */
				if (distance < 500) {
					return restaurant;
				}
				console.log(restaurant.name, distance);
			});
			resolve(geoList);
		});
	};

	App.prototype.renderSteps = function renderSteps() {
		if (this.state.step === 1) {
			return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Pages_Home__["a" /* default */]
			// Props sent to Home component 
			, { choosenCat: this.choosenCat,
				isLocationBased: this.state.isLocationBased,
				handlePosToggle: this.handlePosToggle,
				isLoading: this.state.isLoading,
				disabled: this.state.disabled
			});
		} else if (this.state.step === 2) {
			return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Pages_Randomizer__["a" /* default */]
			// Props sent to Randomizer component
			, { restaurantList: this.state.restaurantsList,
				onRestaurantSelected: this.onRestaurantSelected,
				showInfo: this.showInfo,
				currentPos: this.state.currentPos,
				backToStart: this.backToStart
			});
		} else if (this.state.step === 3) {
			return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Pages_Info__["a" /* default */]
			// Props sent to Info page component
			, { selectedRestaurant: this.state.selectedRestaurant,
				backToStart: this.backToStart,
				currentPos: this.state.currentPos
			});
		}
	};

	App.prototype.render = function render() {
		return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
			'div',
			{ className: 'wrapper' },
			__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_Layout_Header__["a" /* default */], { backToStart: this.backToStart }),
			__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
				'main',
				null,
				this.renderSteps()
			),
			_ref
		);
	};

	return App;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
// Query that fetches the data from the CMS


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_apollo__["graphql"])(Object(__WEBPACK_IMPORTED_MODULE_1_react_apollo__["gql"])(_templateObject))(App));

/***/ })

},[0]);


// WEBPACK FOOTER //
// app.f4fa2c1e.js